module.exports = __webpack_public_path__ + "img/joelkatz.b8deaa6f.png";